import { FC } from 'react';

import type { SalesFocus } from '../../api/client';
import Events from '../events/Events';
import Sales from '../sales/Sales';
import GroupPage, { GroupSection } from './GroupPage';

type ReportsPageProps = {
  section: string | null;
  /** Point the URL at one of this page's sections. */
  onSectionChange: (section: string) => void;
  /** Scope the sales report to one booth on arrival. */
  focus: SalesFocus | null;
  /** Jump to the events section. */
  onOpenEvents: () => void;
  /** Jump to the sales section, optionally scoped to one booth. */
  onOpenSales: (focus: SalesFocus | null) => void;
  onEventsChanged: () => void;
  onExit: () => void;
  onUnauthorized: () => void;
};

const JUMPS = [
  { id: 'sales', label: 'Sales' },
  { id: 'events', label: 'Events' },
];

/** What happened: the sales themselves, and the booths they are filed under. */
const ReportsPage: FC<ReportsPageProps> = ({
  section,
  onSectionChange,
  focus,
  onOpenEvents,
  onOpenSales,
  onEventsChanged,
  onExit,
  onUnauthorized,
}) => {
  const current = JUMPS.some((jump) => jump.id === section) ? section! : 'sales';

  return (
    <GroupPage
      className="reportsPage"
      title="Reports"
      subtitle="What sold, and which booth it was rung up at."
      jumps={JUMPS}
      hashPrefix="reports"
      activeHash={'#reports-' + current}
      scrollTo={section}
      wide
      onSectionNavigate={onSectionChange}
      onExit={onExit}
    >
      <GroupSection id="sales" hashPrefix="reports" label="Sales">
        <Sales onUnauthorized={onUnauthorized} focus={focus} onOpenEvents={onOpenEvents} />
      </GroupSection>
      <GroupSection id="events" hashPrefix="reports" label="Events">
        <Events onUnauthorized={onUnauthorized} onEventsChanged={onEventsChanged} onOpenSales={onOpenSales} />
      </GroupSection>
    </GroupPage>
  );
};

export default ReportsPage;
